import { html } from 'lit';
import { t } from 'src/i18n';
import { customElement, property } from 'lit/decorators.js';
import '../../content/entity-content.js';
import '../../library/editors/index.js';
import '../../library/fields/index.js';
import '../../library/fields/d-expansion.js';
import '../../library/lists/d-list-section-attachment.js';
import '../../pages/computers-page/d-edit-single-related-item.js';
import { DataMapElement } from './data-map-element.js';
import type { NetworkConnectionEditItem } from './network-connection-edit-item';
import type { NetworkConnection } from './network-connection';

/**
 *
 */
@customElement('d-network-connection-view')
export class DNetworkConnectionView extends DataMapElement<NetworkConnection, NetworkConnectionEditItem> {
  @property({ type: String })
  firewall = '';
  @property({ type: String })
  firewallName = '';
  @property({ type: String })
  supplierUuid = '';
  @property({ type: String })
  isp = '';
  @property({ type: String })
  containedNewComputerUuid = '';
  @property({ type: Object })
  containedNewComputer: any = {};
  @property({ type: Boolean })
  connectionOpened = false;
  @property({ type: Boolean })
  firewallOpened = false;
  @property({ type: Boolean })
  networkOpened = false;
  @property({ type: Boolean })
  newElement = false;
  @property({ type: Object })
  viewOptions: any = {};
  @property({ type: Boolean })
  editModeForConnection = false;
  @property({ type: Boolean })
  editModeForFirewall = false;
  @property({ type: Boolean })
  editModeForNetwork = false;

  _operatorTypes() {
    const list = [
      { value: 'UNDEFINED', text: t('computers.options.operatorChoose') },
      { value: 'NONE', text: t('computers.options.none') },
    ];
    list.push(
      { value: 'internal', text: t('computers.options.operatorInternal') },
      { value: 'external', text: t('computers.options.operatorExternal') },
      {
        value: 'internalAndExternal',
        text: t('computers.options.operatorInternalAndExternal'),
      },
    );
    return list;
  }

  _operatorIsExternal(operatorType) {
    return operatorType === 'external' || operatorType === 'internalAndExternal';
  }

  _getOperatorTypeValue(id) {
    let result = '';
    const list = this._operatorTypes();
    for (const item of list) {
      if (id === item.value) {
        result = item.text;
      }
    }

    if (result === t('computers.options.operatorChoose')) {
      result = t('computers.options.notSelected');
    }

    return result;
  }

  _getName(type, uuid) {
    if (Array.isArray(uuid)) {
      uuid = uuid[0];
    }
    for (const item of type) {
      if (item.uuid === uuid) {
        return item.name;
      }
    }
  }

  _displayTypeName(): string {
    return t('computers.connectionView.typeName');
  }

  renderUnitEdit(editItem: NetworkConnectionEditItem) {
    return html`
      ${this.sector === 'HEALTH'
        ? html`<d-section>
            <d-select-dropdown
              theme-page
              field="internetConnections_connectionType"
              .options="${this.connectionTypes}"
              value="${editItem.connectionType}"
              @value-changed=${(e: CustomEvent<{ value: string }>) => {
                e.stopPropagation();
                this.editItem = {
                  ...editItem,
                  connectionType: e.detail.value,
                };
              }}
            >
            </d-select-dropdown>
          </d-section>`
        : ''}
      <d-expansion ?opened=${editItem.connectionType !== 'NONE'}>
        <d-section>
          <d-edit-single-related-item
            field="internetConnections_isp"
            .items=${this.item.partners}
            @new-item=${this.onNewPartner}
            placeholder=${t('computers.placeholder.chooseInternetProvider')}
            .relatedItem=${editItem.supplierUuid}
            @related-item-changed=${(e: CustomEvent<{ relatedItem: string }>) => {
              e.stopPropagation();
              this.editItem = {
                ...editItem,
                supplierUuid: e.detail.relatedItem,
              };
            }}
          >
          </d-edit-single-related-item>
        </d-section>
      </d-expansion>
    `;
  }

  _displayName() {
    return '';
  }

  _isValid() {
    return true;
  }

  initializeEditItem(): NetworkConnectionEditItem {
    // For non-HEALTH sectors, always set connectionType to 'OTHER'
    const connectionType = this.sector !== 'HEALTH' ? 'OTHER' : this.item.connectionType;
    return { connectionType, supplierUuid: this.item.supplierUuid };
  }

  protected typeClasses(): string {
    return 'access';
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-network-connection-view': DNetworkConnectionView;
  }
}
